import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/sr-cover.png";
import video from "../assets/vid/sr-video.mp4";
import { Col } from 'react-bootstrap';
import { renderTextBlock } from 'src/components/RenderTextBlocks';
import Video from 'src/components/Video';


export const projectDetails: ProjectInterface = {
    url: "street-racing",
    title: "Street Racing",
    summary: "Single player “beat-your-own-time” racing game.",
    description: `This is a single-player racing game where you try to finish the race the fastest you can, I did it as the last submission project for the Unity pathway: [Junior Programmer](https://learn.unity.com/pathway/junior-programmer). `,
    year: "2021",
    tags: ["Arcade", "Racing", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: true,
    startVideoTime: 0,
    videoSrc: video,
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.PERSONAL,
    roles: ["Game Programmer", "Prototype"],
    technologies: ["Unity", "C#", "WebGL"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "Unity pathway’s final lap",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/street-racing-unity" },
            { type: 'text', url: "https://play.unity.com/pt/games/fac255fe-31fa-47a7-8b3a-b4de448346b4/street-racing" },
        ],
    relatedProjects: ["WarehouseInvasion", "SUB", "CheckMore"],
};


export function StreetRacing() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        {/* <img src={gif} alt="Gameplay" className='a-image' /> */}
                        <Video src={video} />
                    </div>
                }
                rightContent={
                    null
                }
            >
                <div className='a-body'>
                    <div className="a-body-block">
                        <Col size={12} md={12} className="a-body-left" style={{ marginTop: "0" }}>
                            <div className="a-subtitle">
                                Afterthoughts
                            </div>

                            <div className="a-body-description">
                                {renderTextBlock(`Overall this was a good project to sharpen my basic skills, and even learn some new ones, for example, how to work with vehicle physics and doing a minimap. But I feel that I've done more mistakes than successes in this one. 😪

I have to say that I actually ended up making the same mistakes I did in my last "majorish" project, I did not plan. I didn't plan the gameplay and I didn't plan the coding, also I didn't limit my scope — in this last subject, I actually wanted to just do something very small that implemented object-oriented programming since this was the goal of the submission, but things started to grow and I didn't realize (maybe cuz I wasn't working every day on it).

Frankly, this project took way too long for me to finish it. I was going through some personal problems and I happened to enter a cycle of feeling bad for being unproductive and being unproductive for feeling bad, although this ain't a excuse it definitely made way worse. And affected another [project](https://lucasctnh.com/c1976eedc9ba42478ff5e67ed96257f9?pvs=21) that I was doing in parallel. 😔

So, eventually, I reached a moment where I was just not enjoying working on it anymore and wanted to just give it a finish, and once more I didn't even refactorate the code. In the code you can clearly see that in the beginning I was much more thoughtful of writing a good, concise code, on following game programming patterns... but at a point I was pretty much just throwing stuff there.

I know I could've done a lot more. I would've liked to improve the way the score is handled, to add more intricate gameplay elements and to add a sound management and certainly refactor the code but I felt that I was trying to build a house with a bad foundation whereas I should be making a Lego building all this time. 😞

Anyway, I didn't like to make the same mistakes I've already made because it is like I didn't learn anything but I know I did, so, I guess I just need to keep going and really focus on absorbing and learning with what I'm doing wrong so things like that won't happen again.`)}
                            </div>
                        </Col>
                    </div>
                </div>
            </ProjectBase>
        </div>
    );
}